import { Typography } from "@material-ui/core";
import { get } from "lodash";
import React from "react";

interface IPriceField {
  record?: {};
  source: string;
  label?: string;
}

const CustomPriceField = ({ record = {}, source }: IPriceField) => {
  const price = get(record, source);
  const isPriceDoesntExist = price === null || typeof price === "undefined";

  return (
    <Typography variant="body2">
      {isPriceDoesntExist ? `-` : `$ ${price.toFixed(2) / 100}`}
    </Typography>
  );
};

export default CustomPriceField;
